'use strict';

/*
  ProductSettings

  An object that manages the status of user viewed content. Data is stored to viewedContents model which contains a list of content keys of all viewed content.

  Parameters:
    presenter [APIPresenter] (required):
        Reference to the APIPresenter where the data for the viewed content keys is stored.
*/
function ProductSettings(presenter) {
  this.presenter = presenter;

  this.getViewedContents = function (callback) {
    if (this.presenter.hasAction('account.index_member_contents')) {
      if (this.presenter.models.viewedContents == null || !this.presenter.models.viewedContents._initialized) {
        this.presenter.createModel('viewedContents', {
          action: 'account.index_member_contents'
        }, callback.bind(this));
      } else {
        callback();
      }
    }
  };

  this.createViewedContent = function (contentKey, callback) {
    var _this = this;

    if (this.presenter.models.viewedContents && this.presenter.hasAction('viewedContents.create_member_content')) {
      this.presenter.performAction('viewedContents.create_member_content', {
        key: contentKey
      }, function (data, response) {
        if (data && response === 200) {
          _this.presenter.updateModel('viewedContents', data, function () {
            if (callback) callback(data, response);
          });
        } else {
          console.warn('ProductSettings: Unable to createViewedContent.');
        }
      });
    } else {
      this.getViewedContents(this.createViewedContent.bind(this, contentKey, callback));
    }
  };

  this.hasViewedContent = function (contentKey) {
    if (this.presenter.models.viewedContents && this.presenter.models.viewedContents._initialized) {
      var memberContents = this.presenter.getModelProperty('viewedContents.member_contents');
      var keyContent = memberContents.find(function (item) {
        return item.key === contentKey;
      });
      return !!keyContent;
    }
    // assume they have seen it if anything goes wrong (no harm and more likely)
    return true;
  };
}